import Parse from 'html-react-parser';

function BMP20190(props) {
    let svgCode =
    `<svg width="1384" height="156" viewBox="0 0 1384 156" fill="none" xmlns="http://www.w3.org/2000/svg">
    <style type="text/css">
    .boxStyle rect {
        ${props.boxStyle}
    }
    .paramBoxStyle {
        ${props.boxStyle}
    }
    ${props.fontFace}
    </style>
        <rect width="1384" height="156" fill="${props.backgroundFill}" stroke="${props.outlineColour}" stroke-width="5"/>
        <circle cx="630" cy="63.4546" r="36" fill="${props.paramFill}"/>
        <rect x="627.818" y="22" width="4.36364" height="4.36364" fill="${props.paramFill}"/>
        <rect x="598.551" y="91.8182" width="4.36364" height="4.36364" transform="rotate(-45 598.551 91.8182)" fill="${props.paramFill}"/>
        <rect x="655.091" y="91.6312" width="4.36364" height="4.36364" transform="rotate(-45 655.091 91.6312)" fill="${props.paramFill}"/>
        <circle cx="750" cy="63.4546" r="36" fill="${props.paramFill}"/>
        <rect x="747.818" y="22" width="4.36364" height="4.36364" fill="${props.paramFill}"/>
        <rect x="718.551" y="91.8182" width="4.36364" height="4.36364" transform="rotate(-45 718.551 91.8182)" fill="${props.paramFill}"/>
        <rect x="775.091" y="91.6312" width="4.36364" height="4.36364" transform="rotate(-45 775.091 91.6312)" fill="${props.paramFill}"/>
        <circle cx="510" cy="63.4546" r="36" fill="${props.paramFill}"/>
        <rect x="507.818" y="22" width="4.36364" height="4.36364" fill="${props.paramFill}"/>
        <rect x="478.551" y="91.8182" width="4.36364" height="4.36364" transform="rotate(-45 478.551 91.8182)" fill="${props.paramFill}"/>
        <rect x="535.091" y="91.6312" width="4.36364" height="4.36364" transform="rotate(-45 535.091 91.6312)" fill="${props.paramFill}"/>
        <circle cx="390" cy="63.4546" r="36" fill="${props.paramFill}"/>
        <rect x="387.818" y="22" width="4.36364" height="4.36364" fill="${props.paramFill}"/>
        <rect x="358.551" y="91.8182" width="4.36364" height="4.36364" transform="rotate(-45 358.551 91.8182)" fill="${props.paramFill}"/>
        <rect x="415.091" y="91.6312" width="4.36364" height="4.36364" transform="rotate(-45 415.091 91.6312)" fill="${props.paramFill}"/>
        <circle cx="270" cy="63.4546" r="36" fill="${props.paramFill}"/>
        <rect x="267.818" y="22" width="4.36364" height="4.36364" fill="${props.paramFill}"/>
        <rect x="238.551" y="91.8182" width="4.36364" height="4.36364" transform="rotate(-45 238.551 91.8182)" fill="${props.paramFill}"/>
        <rect x="295.091" y="91.6312" width="4.36364" height="4.36364" transform="rotate(-45 295.091 91.6312)" fill="${props.paramFill}"/>
        <circle cx="1250" cy="63.4546" r="36" fill="${props.paramFill}"/>
        <rect x="1247.82" y="22" width="4.36364" height="4.36364" fill="${props.paramFill}"/>
        <rect x="1218.55" y="91.8182" width="4.36364" height="4.36364" transform="rotate(-45 1218.55 91.8182)" fill="${props.paramFill}"/>
        <rect x="1275.09" y="91.6312" width="4.36364" height="4.36364" transform="rotate(-45 1275.09 91.6312)" fill="${props.paramFill}"/>
        <path class="paramBoxStyle" d="M0 54H175C177.761 54 180 56.2386 180 59V97C180 99.7614 177.761 102 175 102H0V54Z" fill="#A99176"/>
        <g class="boxStyle">
        <rect x="1196" y="112" width="106" height="24" rx="4" fill="${props.paramFill}"/>
        <rect x="855" y="18" width="270" height="90" rx="4" fill="${props.darkFill}"/>
        <rect x="215" y="112" width="588" height="24" rx="4" fill="${props.paramFill}"/>
        </g>
        <g letter-spacing="${props.fontExtras.space}" font-weight="${props.fontExtras.weight}" fill="${props.fontColour}" font-family="${props.fontName}">
        <text fill="black" font-size="27"><tspan x="12" y="88.2285">COMPRESSOR</tspan></text>
        <text font-size="16"><tspan x="238" y="129.969">THRESH</tspan></text>
        <text font-size="16"><tspan x="366" y="129.969">RATIO</tspan></text>
        <text font-size="16"><tspan x="479" y="129.969">ATTACK</tspan></text>
        <text font-size="16"><tspan x="597" y="129.969">RELEASE</tspan></text>
        <text font-size="16"><tspan x="729" y="129.969">GAIN</tspan></text>
        <text font-size="16"><tspan x="886" y="129.969">MULTIBAND</tspan></text>
        <text font-size="16"><tspan x="1234" y="129.969">MIX</tspan></text>
        </g>
        <path d="M159 78L167.66 68.25H150.34L159 78Z" fill="black"/>
    </svg>`

    props.svgReturn(89, svgCode, "bmp00190", 1384, 156);

    return (
        Parse(svgCode)
    );
}

export default BMP20190;